"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "$t", {
  enumerable: true,
  get: function get() {
    return _docsScenarioComponentsLanguagePack.$t;
  }
});
Object.defineProperty(exports, "l10nIniter", {
  enumerable: true,
  get: function get() {
    return _docsScenarioComponentsLanguagePack.scL10nIniter;
  }
});
var _docsScenarioComponentsLanguagePack = require("@tencent/docs-scenario-components-language-pack");